import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scroll to in-page anchors from react-router Link hashes. */
export function HashScroll() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const id = hash.replace(/^#/, "");
    if (!id) return;
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [pathname, hash]);

  return null;
}
